<template>
  <div class="plaform flex">
    <div class=" flex" @click="$router.replace('/user')">
      <img src="../../../static/logo.png" alt="">
      <span>知视猫代理商后台</span>
    </div>
  </div>
</template>

<script>
  import { getLocalStorage, saveLocalStorageString } from '@/utils/auth'

  export default {
    name: 'Index',
    data() {
      return {

      }
    },
    computed: {
      platformDict() {
        return this.$store.state['zsm-user'].platformDict
      },
      userInfo() {
        if (this.$store.state['zsm-user'].userInfo) {
          return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
        } else {
          return JSON.parse(JSON.parse(getLocalStorage('zsm-userInfo')))
        }
      }
    },
    watch: {
      platformDict() {
        location.reload()
        // this.$router.replace(this.$route.path)
        // this.$router.go(0)
      }
    },
    mounted() {

    },
    methods: {
      // 切换平台
      changePlatformCode(platformDict, douyinPlatFormDict) {
        this.$store.dispatch('zsm-user/getByMobileAndPlatform', { // 根据手机号和平台查询用户信息
          mobile: this.userInfo.mobile,
          platformDict
        }).then((info) => {
          if (info.result == 'true') {
            this.$store.state['zsm-user'].platformDict = platformDict // 平台类型  抖音/快手
            this.$store.state['zsm-user'].douyinPlatFormDict = douyinPlatFormDict // 抖音平台类型  抖音/抖店
            saveLocalStorageString('douyinPlatFormDict', douyinPlatFormDict) // 抖音平台类型  抖音/抖店
            this.$store.commit('zsm-user/SET_PLATFORM_DICT', platformDict)
          } else {
            this.$message({ message: info.message, type: 'error' })
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .plaform{
    padding-left: 10px;
    font-size: 13px;
    font-weight: bold;
    font-weight: SourceHanSansSC-regular;
    div{
      align-items: center;
    }
    .line{
      margin: 0 24px;
      width: 1px;
      height: 19px;
      background-color: #fff;
    }
    color: #fff;
    align-items: center;
    // padding: 0 30px;
    img{
      margin-right: 0px;
      width: 40px;
      height: 40px;
    }
  }
  .plaformNo{
    font-family:-webkit-pictograph;
    img{
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }

</style>
